import React from "react";
import "./project.scss";
import { Link } from "react-router-dom";
import { Fade } from "react-reveal";
export default function Project() {
  return (
    <section className="got_project_in_mind">
      <div className="container">
        <Fade bottom duration={600} delay={400}>
          <h5 className="heading" title="Got a Project in Mind?">GOT A PROJECT IN MIND?</h5>
        </Fade>
        <Fade bottom duration={700} delay={500}>
          <p>
            Have a project idea brewing in your mind? Share your innovative
            vision with Vedhas AI Technologies. Our dedicated team is poised and
            ready to collaborate with you every step of the way, offering our
            expertise and innovative solutions to bring your ideas to fruition.
          </p>
        </Fade>
        <Link to={"/contact"}>
          <Fade bottom duration={800} delay={600}>
            <button title="Drop a Message">Drop a Message</button>
          </Fade>
        </Link>
      </div>
    </section>
  );
}
